import { COMMON_BASE_URL } from '../../../envs'
import { HttpClient } from '../http-client'
export class CentsStripeClient {

  private readonly httpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async get(): Promise<string> {
    const response = await this.httpClient.fetch(`${COMMON_BASE_URL}/stripe/public-key`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Error while retrieving charity: ${response.status}`)
    }
    const { publicKey } = await response.json()
    return publicKey
  }
}
